import React, {Component} from 'react'
import {Grid, Row, Col, Dropdown, MenuItem, Glyphicon, FormGroup, FormControl, InputGroup, HelpBlock, Modal} from 'react-bootstrap'
import * as moment from 'moment'
import DatePicker from 'react-bootstrap-datetimepicker'

import Constants from '../../../Phi/Constants'
import * as ValidationUtils from '../../../Utils/ValidationUtils'

import GraphMetricCircular from '../../../Components/GraphMetricCircular'
import ButtonReportLink from '../../../Components/ButtonReportLink'
import DialogTalkToExpert from '../../DialogTalkToExpertContainer'
import DialogRequestAppointment from '../../DialogRequestAppointmentContainer'
//import DialogReportViewer from '../../DialogReportViewer';

import './Dashboard.css'

import HSGLogo from '../../../Assets/hsg-logo-sm.png'
import avatarBoy from '../../../Assets/avatar-child-boy.png'
import avatarGirl from '../../../Assets/avatar-child-girl.png'
import icoWeight from '../../../Assets/ico-weight.png'
import icoBMI from '../../../Assets/ico-bmi.png'
import icoGrowthNormal from '../../../Assets/ico-growth-normal.png'
import icoPhysical from '../../../Assets/ico-physical.png'
import icoDental from '../../../Assets/ico-dental.png'
import icoEnt from '../../../Assets/ico-ent.png'
import icoEye from '../../../Assets/ico-eye.png'
import Loader from 'dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent'

// Constants
const BUTTON_CONTACT_EXPERT = 'TALK TO A HEALTHSETGO EXPERT'
const BUTTON_REQUEST_APPOINTMENT = 'REQUEST APPOINTMENT'
const BUTTON_VISIT_WEBSITE = 'VISIT WEBSITE'

const WELCOME_PRETEXT = 'Welcome, '
const WELCOME_ENDTEXT = '!'

const METRICS_INFO = 'All HealthSetGo assessments are benchmarked with the Indian Academy of Pediatrics Growth Standards for Children (IAP) and the World Health Organizations (WHO) growth charts.'

const METRICS_INFO_FLIP_POINT = 1199
const SM = 991

const METRIC_GRAPH_HEIGHT = 240

const assessmentMap = {
	growth: {name: 'Growth Assessment', image: icoGrowthNormal},
	physical: {name: 'Physical Assessment', image: icoPhysical},
	dental: {name: 'Dental Assessment', image: icoDental},
	ent: {name: 'ENT Assessment', image: icoEnt},
	eye: {name: 'Eye Assessment', image: icoEye}
}

class Dashboard extends Component {
	constructor(props) {
		super(props)

		this.state = {
			selectedAssessment: 0,
			selectedAssessmentId: null,
			showDialogReportViewer: false,

			reportStatus: {
				growth: ButtonReportLink.STATE_NORMAL,
				physical: ButtonReportLink.STATE_NORMAL,
				ent: ButtonReportLink.STATE_NORMAL,
				eye: ButtonReportLink.STATE_NORMAL,
				dental: ButtonReportLink.STATE_NORMAL
			},

			activationCode: '',
			activationCodeError: '',
			dob: moment().format('YYYY-MM-DD'),
			dobError: '',

			otp: '',
			otpError: '',
			resendOtp: true
		}

		this.handleChangeActivationCode = this.handleChangeActivationCode.bind(this)
		this.handleChangeDOB = this.handleChangeDOB.bind(this)
		this.handleChangeOTP = this.handleChangeOTP.bind(this)
	}

	componentDidMount() {
		if (this.props.childList.length && this.props.childList[this.props.selectedChild].metric && this.props.childList[this.props.selectedChild].metric.length) {
			const studentId = this.props.childList[this.props.selectedChild].userId
			const eventTrackId = this.props.childList[this.props.selectedChild].metric[this.state.selectedAssessment].eventTrackId

			// Get individual assessment status
			this.props.fetchStudentAssessmentStatus(studentId, eventTrackId)
		}
	}

	componentWillReceiveProps(newProps) {
		if (
			this.props.selectedChild !== newProps.selectedChild &&
			Boolean(newProps.childList[newProps.selectedChild].metric) &&
			newProps.childList[newProps.selectedChild].metric.length
		) {
			this.setState({selectedAssessment: 0})

			const studentId = newProps.childList[newProps.selectedChild].userId
			const eventTrackId = newProps.childList[newProps.selectedChild].metric[0].eventTrackId

			this.props.fetchStudentAssessmentStatus(studentId, eventTrackId)
		}

		if (this.props.childList !== newProps.childList && newProps.childList.length && newProps.childList[newProps.selectedChild || 0]) {

			let child = newProps.childList[newProps.selectedChild || 0]
			if(child.metric && child.metric.length && child.metric[this.state.selectedAssessment || 0]) {
				this.props.fetchStudentAssessmentStatus(child.userId, child.metric[this.state.selectedAssessment || 0].eventTrackId)
			}
		}

		if (newProps.addChild.codeVerified) {
			if (newProps.addChild.codeStatus && !this.props.addChild.codeStatus) {
				this.setState({activationCodeError: ''})
			}

			if (!newProps.addChild.codeStatus) {
				this.setState({activationCodeError: 'Activation Code is not valid'})
			}
		}

		if (!newProps.isLoadingReportStatus && this.props.isLoadingReportStatus && newProps.statusList.length) {

			const reportStatus = {
				growth: this.getReportStatus(newProps, Constants.reportStatus.GROWTH),
				physical: this.getReportStatus(newProps, Constants.reportStatus.PHYSICAL),
				ent: this.getReportStatus(newProps, Constants.reportStatus.ENT),
				eye: this.getReportStatus(newProps, Constants.reportStatus.EYE),
				dental: this.getReportStatus(newProps, Constants.reportStatus.DENTAL)
			}

			this.setState({reportStatus})
		}

		if (!newProps.verifyOtp.isLoading && this.props.verifyOtp.isLoading && newProps.verifyOtp.status) {
			this.props.getUser()
		}
	}

	getPartnerImage = () => {
		const selectedChild = this.props.childList.length ? this.props.childList[this.props.selectedChild] : null
		const selectedAssessment = this.state.selectedAssessment || 0
		const imageTypeMap = {
			object: partnerLogo => Array.isArray(partnerLogo) && partnerLogo[0],
			string: partnerLogo => partnerLogo
		}
		const partnerLogo = (selectedChild && selectedChild.mspDetails && selectedChild.mspDetails[selectedAssessment] && selectedChild.mspDetails[selectedAssessment].partnerLogo) || null
		return Boolean(partnerLogo) ? imageTypeMap[typeof partnerLogo](partnerLogo) : null
	}

	getYearlyDropDown = assessmentEventList => (
		Boolean(assessmentEventList) &&
		assessmentEventList.length && (
			<Col className="hsg-dashboard-dropdown-sry-container">
				<span className="hsg-dashboard-dropdown-sry-label">View Assessments</span>

				<Dropdown id="dropdown-select-report-year" className="hsg-dashboard-dropdown-sry-wrapper">
					<span className="hsg-dashboard-dropdown-sry-text" style={{float: 'left'}}>
						{assessmentEventList.length && assessmentEventList[this.state.selectedAssessment].name}
					</span>

					<Dropdown.Toggle bsStyle="success" className="hsg-dashboard-dropdown-sry-toggle" />

					<Dropdown.Menu>{this.renderReportSelectionDropdown(assessmentEventList)}</Dropdown.Menu>
				</Dropdown>
			</Col>
		)
	)

	// render() {
		

	// 	// if (Boolean(childList) && childList.length) {
	// 	// 	child = childList[selectedChild]

	// 	// 	if (child &&Boolean(child.assessmentList) && child.assessmentList.length) {
	// 	// 		if (Boolean(child.assessmentList[this.state.selectedAssessment].metric_custom_json.data)) {
	// 	// 			const data = child.assessmentList[this.state.selectedAssessment].metric_custom_json.data
	// 	// 			height = data.height
	// 	// 			weight = data.weight
	// 	// 			// find((item) => item.key === data.weight_range)
	// 	// 			heightColor = Constants.heightRange.find(item => item.key === data.height_range).color
	// 	// 			wightColor = Constants.weightRange[1].color
	// 	// 			bmiColor = Constants.bmiRange.find(item => item.key === data.bmi_range).color
    //     //         }
	// 	) : null

	showIncompleteMSG = (msg) => this.setState({incompleteMSG: msg, showIncompleteMSG: !!msg})

	dialogIncompleteMSG = () => (
		<Modal
			show={this.state.showIncompleteMSG}
			onHide={()=>this.showIncompleteMSG()}
			onClose={()=>this.showIncompleteMSG()}
		>
		<Modal.Header closeButton>
			<Modal.Title><span className="hsg-dra-title-text">Information</span></Modal.Title>
		</Modal.Header>
        <Modal.Body style={{margin: '0 20px 20px'}}>

			<p className="hsg-dra-body-text">
				{this.state.incompleteMSG}
			</p>
        </Modal.Body>
        </Modal>
	)

	renderSideSections = (child) => (
		<div className="hsg-dashboard-side-panel-container">
			<div className="hsg-dashboard-avatar-container">
				<img src={child.gender === 'F' ? avatarGirl : avatarBoy} className="hsg-dashboard-avatar-image" />

				<p className="hsg-dashboard-avatar-name">{this.formatName(child.name)}</p>

				<div className="hsg-dashboard-primary-panel-button" onClick={this.props.onClickTalkToExpert}>
					{BUTTON_CONTACT_EXPERT}
				</div>
			</div>

			<div className="hsg-dashboard-side-panel-divider" />

			{this.getPartnerImage() && <div className="hsg-dashboard-partner-panel-container">
				<div>
					<div className="hsg-dashboard-partner-container">
						<p className="hsg-dashboard-partner-heading">OUR MEDICAL PARTNER</p>

						<div>
							<img className="hsg-dashboard-partner-image" src={this.getPartnerImage()} />
						</div>
					</div>
				</div>

				{/* <div className="hsg-dashboard-primary-panel-button"
	onClick={this.props.onClickRequestAppointment}>
	
	{BUTTON_REQUEST_APPOINTMENT}
	
</div> */}

				{/* <div className="hsg-dashboard-secondary-panel-button">
	{BUTTON_VISIT_WEBSITE}
</div> */}
			</div>}
		</div>
	)

	render() {
		let child = null;

        let { childList, selectedChild } = this.props;
		let { selectedAssessment } = this.state

        let height = 0,
            weight = 0,
            assessmentEventList = [];

        let heightColor = Constants.heightRange[1].color;
        let wightColor = Constants.weightRange[1].color;
        let bmiColor = Constants.bmiRange[1].color;

        if (Boolean(childList) && childList.length) {
            child = childList[selectedChild];

            assessmentEventList = child && child.metric ? child.metric.map(item => ({ name: item.assessmentDate, eventId: item.eventTrackId })) : null;
            height = child.bmis && child.bmis.length && child.bmis[selectedAssessment || 0].height || null;
            weight = child.bmis && child.bmis.length && child.bmis[selectedAssessment || 0].weight || null;
        }

		let assessmentStatusRemarks = this.getAssessmentStatusRemarks() 
                
        //         // if (Boolean(child.assessmentList[this.state.selectedAssessment].metric_custom_json.data)) {


		// 		// 	const data = child.assessmentList.filter(element => element.metric_custom_json.data)
		// 		// 	height = data.height
		// 		// 	weight = data.weight
		// 		// 	// find((item) => item.key === data.weight_range)
		// 		// 	heightColor = Constants.heightRange.find(item => item.key === data.height_range).color
		// 		// 	wightColor = Constants.weightRange[1].color
		// 		// 	bmiColor = Constants.bmiRange.find(item => item.key === data.bmi_range).color
		// 		// }

		// 		assessmentEventList = child.assessmentList.map(item => ({name: item.assessment_date}))
		// 	}
		// }

		// if(child === null ||
		// !Boolean(child.assessmentList) ||
		// child.assessmentList.length === 0 ||
		// !Boolean(child.assessmentList[0].metric_custom_json.data)) {
		//     return (
		//     <section>
		//     <div
		//         style={{
		//             marginTop: 100,
		//             textAlign: 'center',
		//             fontSize: 16,
		//             color: '#666666'
		//         }}>
		//         No reports published for the selected child.
		//     </div>
		//     </section>);
		// }

		return (
			<section className="hsg-dashboard-container">
				{/* Main Dashboard Layout */}
				{/*Boolean(this.props.otpInfo) &&
            this.props.otpInfo.verified &&*/
				Boolean(this.props.childList) && Boolean(this.props.childList.length) ? (
					<Grid fluid>
						<Row className="show-grid">
							{/* Main Content */}
							<Col md={9} lg={10} mdPush={3} lgPush={2} style={{padding: 0}}>
								<div className="hsg-dashboard-content-container">
									{/* Content Body, contains metrics and report links */}
									<div className="hsg-dashboard-content-body-container">
										{/* Content Header, displays user name and current date */}
										<div className="hsg-dashboard-content-header-container">
											<p className="hsg-dashboard-content-header-title">{WELCOME_PRETEXT + this.formatName(this.props.user.fullName) + WELCOME_ENDTEXT}</p>

											<p className="hsg-dashboard-content-header-subtitle">{'Today is ' + this.getformatedCurrentDate()}</p>

											<hr />
										</div>

										{/* Child Name displayed only on small devices */}
										{window.innerWidth <= SM && (
											<Row className="show-grid">
												<Col>
													<div className="hsg-dashboard-child-name">
														<p>{this.formatName(child.name)}</p>
														<hr />
													</div>
												</Col>
											</Row>
										)}

										{/* Child General Metric Graphs */}
										{
										child.associationActive === Constants.activeStatusMap.REJECTED ? (
												<section>
													<div
														style={{
															marginTop: 100,
															textAlign: 'center',
															fontSize: 16,
															color: '#666666'
														}}
													>
														Child has been deactivated by you. HSG head office have been notified on this. Will fix this as soon as possible.
													</div>
												</section>
										) : !!!(child.metric && child.metric.length && child.metric[selectedAssessment] && child.metric[selectedAssessment].assessmentFlag) 
										? (
											<section>
												<div
													style={{
														marginTop: 100,
														textAlign: 'center',
														fontSize: 16,
														color: '#666666'
													}}
												>
													No reports published for the selected child.
												</div>
												{this.getYearlyDropDown(assessmentEventList)}
											</section>
										) : (
											<div>
												<Row className="show-grid">
													{window.innerWidth > METRICS_INFO_FLIP_POINT && (
														<Col lg={4} className="hsg-dashboard-metrics-info-container">
															<div className="hsg-dashboard-metrics-info-wrapper-centered">{METRICS_INFO}</div>
														</Col>
													)}
													<Col lg={8}>
													<div className="hsg-dashboard-metrics-container">

													{
														true ? 
														<Row>
															<Col xs={6} sm={4}>
																<div className="hsg-dashboard-metric-item-holder">
																	<GraphMetricCircular
																		heightBound={window.innerWidth > METRICS_INFO_FLIP_POINT}
																		height={METRIC_GRAPH_HEIGHT}
																		dim={this.props.dim}
																		metricName="CURRENT HEIGHT"
																		metricValue={parseFloat(height)}
																		metricUnit="centimeters"
																		metricGlyph="resize-vertical"
																		options={{metricValueColor: heightColor}}
																	/>
																</div>
															</Col>

															<Col xs={6} sm={4}>
																<div className="hsg-dashboard-metric-item-holder">
																	<GraphMetricCircular
																		heightBound={window.innerWidth > METRICS_INFO_FLIP_POINT}
																		height={METRIC_GRAPH_HEIGHT}
																		dim={this.props.dim}
																		metricName="CURRENT WEIGHT"
																		metricValue={parseFloat(weight)}
																		metricUnit="kilograms"
																		metricIcon={icoWeight}
																		options={{metricValueColor: wightColor}}
																	/>
																</div>
															</Col>

															<Col xs={6} sm={4}>
																<div className="hsg-dashboard-metric-item-holder">
																	<GraphMetricCircular
																		heightBound={window.innerWidth > METRICS_INFO_FLIP_POINT}
																		height={METRIC_GRAPH_HEIGHT}
																		dim={this.props.dim}
																		metricName="CURRENT BMI"
																		metricValue={this.calculateBmi(height, weight)}
																		metricIcon={icoBMI}
																		options={{metricValueColor: bmiColor}}
																	/>
																</div>
															</Col>
														</Row>
													 : <div> {} </div> 
													}
													</div>														
													</Col>

												</Row>

												{/* Report Links Container */}
												<Row className="show-grid">
													{/* Dropdown for selecting a particular year's report */}
													{this.getYearlyDropDown(assessmentEventList)}

													{this.props.isLoadingReportStatus ? (
														<div style={{padding: 40}}>
															<Loader />
														</div>
													) : (
														<Col className="hsg-dashboard-report-links-container">
															<Row className="show-grid">
																{/* {this.renderReportLinks(this.props.reportList)} */}

																<Col lg={4} sm={6}>
																	<ButtonReportLink
																		name="GROWTH ASSESSMENT"
																		icon={icoGrowthNormal /*glyph="signal"*/}
																		displayState={this.state.reportStatus.growth}
																		incompleteMSG={assessmentStatusRemarks[Constants.reportStatus.GROWTH].name}
																		dim={this.props.dim}
																		onClick={() => {
																			assessmentStatusRemarks[Constants.reportStatus.GROWTH].name 
																				? this.showIncompleteMSG(assessmentStatusRemarks[Constants.reportStatus.GROWTH].value) 
																				: this.showPentahoReport(Constants.pentahoReports.GROWTH)
																		}}
																	/>
																</Col>

																<Col lg={4} sm={6}>
																	<ButtonReportLink
																		name="PHYSICAL ASSESSMENT"
																		icon={icoPhysical /*glyph="user"*/}
																		displayState={this.state.reportStatus.physical}
																		incompleteMSG={assessmentStatusRemarks[Constants.reportStatus.PHYSICAL].name}
																		dim={this.props.dim}
																		onClick={() => {
																			assessmentStatusRemarks[Constants.reportStatus.PHYSICAL].name 
																				? this.showIncompleteMSG(assessmentStatusRemarks[Constants.reportStatus.PHYSICAL].value) 
																				: this.showPentahoReport(Constants.pentahoReports.PHYSICAL)
																		}}
																	/>
																</Col>

																<Col lg={4} sm={6}>
																	<ButtonReportLink
																		name="ENT ASSESSMENT"
																		icon={icoEnt /*glyph="volume-up"*/}
																		displayState={this.state.reportStatus.ent}
																		incompleteMSG={assessmentStatusRemarks[Constants.reportStatus.ENT].name}
																		dim={this.props.dim}
																		onClick={() => {
																			assessmentStatusRemarks[Constants.reportStatus.ENT].name 
																				? this.showIncompleteMSG(assessmentStatusRemarks[Constants.reportStatus.ENT].value) 
																				: this.showPentahoReport(Constants.pentahoReports.ENT)
																		}}
																	/>
																</Col>

																<Col lg={4} sm={6}>
																	<ButtonReportLink
																		name="EYE ASSESSMENT"
																		icon={icoEye /*glyph="eye-open"*/}
																		displayState={this.state.reportStatus.eye}
																		incompleteMSG={assessmentStatusRemarks[Constants.reportStatus.EYE].name}
																		dim={this.props.dim}
																		onClick={() => {
																			assessmentStatusRemarks[Constants.reportStatus.EYE].name
																				? this.showIncompleteMSG(assessmentStatusRemarks[Constants.reportStatus.EYE].value) 
																				: this.showPentahoReport(Constants.pentahoReports.EYE)
																		}}
																	/>
																</Col>

																<Col lg={4} sm={6}>
																	<ButtonReportLink
																		name="DENTAL ASSESSMENT"
																		icon={icoDental /*glyph="apple"*/}
																		displayState={this.state.reportStatus.dental}
																		incompleteMSG={assessmentStatusRemarks[Constants.reportStatus.DENTAL].name}
																		dim={this.props.dim}
																		onClick={() => {
																			assessmentStatusRemarks[Constants.reportStatus.DENTAL].name
																				? this.showIncompleteMSG(assessmentStatusRemarks[Constants.reportStatus.DENTAL].value) 
																				: this.showPentahoReport(Constants.pentahoReports.DENTAL)
																		}}
																	/>
																</Col>
															</Row>
														</Col>
													)}
												</Row>
											</div>
										)}

										{window.innerWidth <= METRICS_INFO_FLIP_POINT && (
											<Row className="show-grid">
												<Col xs={12}>
													<div className="hsg-dashboard-metrics-info-wrapper">{METRICS_INFO}</div>
												</Col>
											</Row>
										)}
									</div>
								</div>
							</Col>

							{/* Side Panel */}
							<Col md={3} lg={2} mdPull={9} lgPull={10} style={{padding: 0}}>
								{this.renderSideSections(child || {})}
							</Col>

							{/* Pop in Dialogs */}

							{/* {this.state.showDialogReportViewer &&
                    <DialogReportViewer
                        open={this.state.showDialogReportViewer}
                        onClose={() => this.setState({showDialogReportViewer: false})} />} */}
						</Row>
					</Grid>
				) : (
					<div className="hsg-dashboard-content-container">
						{/* Content Body, contains metrics and report links */}

						<Col md={9} lg={10} mdPush={3} lgPush={2} style={{padding: 0}}>
							<div className="hsg-dashboard-content-body-container">
								{/* Content Header, displays user name and current date */}
								<div className="hsg-dashboard-content-header-container">
									<p className="hsg-dashboard-content-header-title">{WELCOME_PRETEXT + this.formatName(this.props.user.fullName) + WELCOME_ENDTEXT}</p>

									<p className="hsg-dashboard-content-header-subtitle">{'Today is ' + this.getformatedCurrentDate()}</p>

									<hr />
								</div>

								<section>
								<div
									style={{
										marginTop: 100,
										textAlign: 'center',
										fontSize: 16,
										color: '#666666'
									}}
								>
									Oops! Looks like you faced an issue while accessing your child's reports, but do not worry we are working on it and will 
									inform you as soon as it is fixed.
								</div>
							</section>
							</div>
						</Col>
						<Col md={3} lg={2} mdPull={9} lgPull={10} style={{padding: 0}}>
							{this.renderSideSections(child || {})}
						</Col>
						

						
					</div>
				)}

				{/* Case No Associated Child, Prompt assocation using activation code */}

				{/*Boolean(this.props.otpInfo) && this.props.otpInfo.verified && false &&
            (!Boolean(this.props.childList) ||
            !Boolean(this.props.childList.length))*/ false && (
					<div className="hsg-dashboard-add-child-container">
						<img className="hsg-dashboard-add-child-logo" alt="Health Set Go" src={HSGLogo} />

						<div className="hsg-dashboard-add-child-card">
							<h2 className="hsg-dashboard-add-child-heading">Add A Child</h2>

							<p className="hsg-dashboard-add-child-subheading">Please provide the Date of Birth and the Activation Code for your child.</p>

							<DatePicker
								defaultText={'Please select a date'}
								dateTime={this.state.dob}
								format="YYYY-MM-DD"
								inputFormat="DD/MM/YYYY"
								viewMode="years"
								mode="date"
								onChange={this.handleChangeDOB}
							/>

							{/* <FormGroup
                        controlId="input-dob"
                        validationState={this.validateDOB()}>

                        <FormControl
                            type="text"
                            value={this.state.dob}
                            placeholder="Date of Birth (yyyy-mm-dd)"
                            onChange={this.handleChangeDOB} />
                        <FormControl.Feedback />

                        {this.validateDOB() !== 'success' && this.validateDOB() !== null &&
                            <HelpBlock>{this.state.dobError}</HelpBlock>}

                    </FormGroup> */}

							<div style={{height: 20}} />

							<FormGroup controlId="input-activation-code" validationState={this.validateActivationCode()}>
								<InputGroup>
									<InputGroup.Addon>
										<span>
											<Glyphicon glyph="lock" />
										</span>
									</InputGroup.Addon>

									<FormControl
										type="text"
										value={this.state.activationCode}
										placeholder="Activation Code"
										onChange={this.handleChangeActivationCode}
										disabled={this.validateDOB() !== 'success'}
									/>
								</InputGroup>
								<FormControl.Feedback style={{zIndex: 1000}} />

								{this.validateActivationCode() !== 'success' && this.validateActivationCode() !== null && <HelpBlock>{this.state.activationCodeError}</HelpBlock>}
							</FormGroup>

							{this.props.addChild.isLoading ? (
								<div style={{paddingTop: 20}}>
									<Loader />
								</div>
							) : (
								<div>
									<div className="hsg-dashboard-add-child-button" onClick={() => this.handleAddChild()}>
										CONTINUE
									</div>

									<div className="hsg-dashboard-add-child-response">{!this.props.addChild.status && Boolean(this.props.addChild.error) && this.props.addChild.error}</div>
								</div>
							)}
						</div>
					</div>
				)}

				{/* Case OTP not verified */}
				{/*(!Boolean(this.props.otpInfo) || !this.props.otpInfo.verified) &&*/ false && (
					<div className="hsg-dashboard-verify-otp-container">
						<img className="hsg-dashboard-verify-otp-logo" alt="Health Set Go" src={HSGLogo} />

						<div className="hsg-dashboard-verify-otp-card">
							<h2 className="hsg-dashboard-verify-otp-heading">Phone Verification</h2>

							<p className="hsg-dashboard-verify-otp-subheading">
								Your phone number needs to be verified using an OTP (One Time Password). We have sent a Text Message to your phone number containing an OTP. Kindly fill in the OTP
								below.
							</p>

							<FormGroup controlId="input-otp" validationState={this.validateOTP()}>
								<FormControl type="text" value={this.state.otp} placeholder="OTP" onChange={this.handleChangeOTP} />
								<FormControl.Feedback />

								{this.validateOTP() !== 'success' && this.validateOTP() !== null && <HelpBlock>{this.state.otpError}</HelpBlock>}
							</FormGroup>

							{(!this.props.verifyOtp.isLoading || !this.props.verifyOtp.status) &&
								(!this.props.verifyOtp.sendOtpStatus ? (
									<div className="hsg-dashboard-verify-otp-resend-link">
										<span style={{cursor: 'pointer'}} onClick={() => this.handleSendOTP()}>
											SEND OTP AGAIN
										</span>
									</div>
								) : this.props.verifyOtp.otpSent ? (
									<div className="hsg-dashboard-verify-otp-resend-text">
										<span style={{color: 'green'}}>OTP SENT</span>
									</div>
								) : (
									<div className="hsg-dashboard-verify-otp-resend-text">
										<span style={{color: 'red'}}>FAILED TO SEND OTP</span>
									</div>
								))}

							{this.props.verifyOtp.isLoading || this.props.verifyOtp.status ? (
								<div style={{paddingTop: 20}}>
									<Loader />
								</div>
							) : (
								<div>
									<div className="hsg-dashboard-verify-otp-button" onClick={() => this.handleVerifyOTP()}>
										VERIFY OTP
									</div>

									<div className="hsg-dashboard-verify-otp-response">{!this.props.verifyOtp.status && Boolean(this.props.verifyOtp.error) && this.props.verifyOtp.error}</div>
								</div>
							)}
						</div>
					</div>
				)}

				{this.dialogIncompleteMSG()}
			</section>
		)
	}

	// Rendering Methods

	renderReportSelectionDropdown(eventList) {
		return eventList.map((item, pos) => (
			<MenuItem
				key={pos}
				eventKey={'' + pos}
				onSelect={(eventKey) => {
					this.handleReportYearSelection(parseInt(eventKey))
				}}
			>
				{item.name}
			</MenuItem>
		))
	}

	renderReportLinks(reportList) {
		return reportList.map((item, pos) => (
			<Col key={pos} lg={4} sm={6}>
				<ButtonReportLink
					name={item.name}
					glyph={item.glyph}
					displayState={pos < 3 ? ButtonReportLink.STATE_NORMAL : ButtonReportLink.STATE_NEED_ATTENTION}
					dim={this.props.dim}
					onClick={() => {}}
				/>
			</Col>
		))
	}

	// Event Listeners

	handleChangeActivationCode(e) {
		this.setState({activationCode: e.target.value})

		if (e.target.value.length > 7) this.props.verifyCode(e.target.value, this.state.dob)
	}

	handleChangeDOB(date) {
		this.setState({dob: date})

		if (this.validateActivationCode() !== null) this.props.verifyCode(this.state.activationCode, date)
	}

	handleChangeOTP(e) {
		this.setState({otp: e.target.value})
	}

	handleAddChild() {
		if (this.validateActivationCode() === 'success' && this.validateDOB() === 'success') {
			this.props.addChildUsingActivationCode({
				userName: this.props.user.email,
				activationCode: this.state.activationCode,
				dob: this.state.dob
			})
		}
	}

	handleVerifyOTP() {
		if (this.validateOTP() === 'success') {
			this.props.handleVerifyOtp(this.props.user.email, this.state.otp)
		}
	}

	handleSendOTP() {
		if (this.state.resendOtp) {
			this.props.sendOtp(this.props.user.email)
			this.setState({resendOtp: false})
		}
	}

	// Other Methods

	validateActivationCode(str) {
		if (!str) str = this.state.activationCode

		if (str.length > 7 && this.props.addChild.codeVerified && this.props.addChild.codeStatus) return 'success'
		else if (str.length > 0) return 'error'

		return null
	}

	validateDOB(str) {
		if (!str) str = this.state.dob

		if (ValidationUtils.date_yyyy_mm_dd(str)) return 'success'
		else if (str.length > 0) return 'error'

		return null
	}

	validateOTP(str) {
		if (!str) str = this.state.otp

		if (str.length > 0 && !isNaN(str)) return 'success'
		else if (str.length > 0) return 'error'

		return null
	}

	getformatedCurrentDate() {
		return moment().format("dddd, Do MMM'YYYY")
	}

	calculateBmi(height, weight) {
		height = parseFloat(height) / 100
		weight = parseFloat(weight)

		const bmi = weight / (height * height)

		return this.trimFloat(bmi)
	}

	trimFloat(value) {
		return Number(parseFloat(Math.round(parseFloat(value * 100).toFixed(3)) / 100).toFixed(2))
	}

	formatName(name) {
		if (typeof name !== 'string') return ''

		name = name.toLowerCase().trim()

		let result = ''

		for (let i = 0; i < name.length; i++) {
			const char = name.charAt(i)

			if (i === 0) {
				result = char.toUpperCase()
			} else if (name.charAt(i - 1) === ' ' || name.charAt(i - 1) === '.') {
				result += char.toUpperCase()
			} else {
				result += char
			}
		}

		return result
	}

	getAssessmentStatusRemarks = () => {
		let status = {
			[Constants.reportStatus.GROWTH]: {},
			[Constants.reportStatus.PHYSICAL]: {},
			[Constants.reportStatus.ENT]: {},
			[Constants.reportStatus.EYE]: {},
			[Constants.reportStatus.DENTAL]: {}		
		}
		
		this.props.statusList && this.props.statusList.map(item => status = Object.assign({}, status, {[item.name]: item.remarks && JSON.parse(item.remarks) || {}}))
		return status 
	}

	getReportStatus(props, name) {

		const status = props.statusList.find(item => item.name === name)
		if (status && status.status === 'Normal' && !!!status.remarks ) {
			return ButtonReportLink.STATE_NORMAL
		} else if(status && status.remarks && JSON.parse(status.remarks).value){
			return ButtonReportLink.STATE_INCOMPLETED
		} else return ButtonReportLink.STATE_NEED_ATTENTION
	}

	handleReportYearSelection(index) {
        this.setState({ selectedAssessment: index });

        const studentId = this.props.childList[this.props.selectedChild].userId;
        const eventTrackId = this.props.childList[this.props.selectedChild].metric[index].eventTrackId;

        this.props.fetchStudentAssessmentStatus(studentId, eventTrackId);
    }

    showPentahoReport(name) {
        const uuId = this.props.childList[this.props.selectedChild].uuId;
        const eventTrackId = this.props.childList[this.props.selectedChild].metric[this.state.selectedAssessment]
            .eventTrackId;

        this.openReportNewTab(eventTrackId, uuId, name);
    }

	// handleReportYearSelection(index) {
    //     this.setState({ selectedAssessment: index });

    //     const studentId = this.props.childList[this.props.selectedChild].userId;
    //     const eventTrackId = this.props.childList[this.props.selectedChild].metric[index].eventTrackId;

    //     this.props.fetchStudentAssessmentStatus(studentId, eventTrackId);
    // }

	// showPentahoReport(name) {
	// 	const uuId = this.props.childList[this.props.selectedChild].uuId
	// 	const eventTrackId = this.props.childList[this.props.selectedChild].assessmentList[this.state.selectedAssessment].event_track_id

	// 	this.openReportNewTab(eventTrackId, uuId, name)

	// 	/*if(!this.props.isLoadingReport &&
    //     !this.props.reportError &&
    //     Boolean(this.uuId) &&
    //     this.uuId === uuId &&
    //     Boolean(this.reportEventTrackId) &&
    //     this.reportEventTrackId === eventTrackId &&
    //     this.props.reportName === name &&
    //     this.props.report.length) {
    //         this.setState({showDialogReportViewer: true});
    //     }

    //     else {
    //         this.props.fetchPentahoReport(name, uuId, eventTrackId);
    //         this.setState({showDialogReportViewer: true});

    //         this.uuId = uuId;
    //         this.reportEventTrackId = eventTrackId;
    //     }*/
	// }

	openReportNewTab = (event, child, type) => {
		window.open('/report/' + event + '/' + child + '/' + type, '_blank')
	}
}

export default Dashboard
